module.exports = "/assets/data/e85f913b5ba68f5a279ae7aa247190f3-SA2.data.json";